export const TEXT_SIZE = 1024;
export const FILE_SIZE = 15728640;
